require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./entrepreneurship-is-still-a-boys-club.json") })
        }
      }, "path---entrepreneurship-is-still-a-boys-club");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---entrepreneurship-is-still-a-boys-club!./.cache/json/entrepreneurship-is-still-a-boys-club.json
// module id = 1088
// module chunks = 231608221292675